import type { FC, PropsWithChildren } from 'react';
import React from 'react';

type VisibleIndentation = {
  indentation: number;
  nodeId: string;
} | null;

type VisibleIndentationContextProps = {
  visibleIndentation: VisibleIndentation;
};

type ContextType = {
  visibleIndentation: VisibleIndentation;
};

export const VisibleIndentationContext = React.createContext<ContextType>(
  null as unknown as ContextType
);

export const VisibleIndentationContextProvider: FC<
  PropsWithChildren<VisibleIndentationContextProps>
> = ({ visibleIndentation, children }) => {
  return (
    <VisibleIndentationContext.Provider value={{ visibleIndentation }}>
      {children}
    </VisibleIndentationContext.Provider>
  );
};
